export const language: any = {
  add_by_image: "Thêm bằng hình ảnh",
  add_image_by_camera: "Chụp bằng camera",
  add_image_by_gallery: "Chọn hình ảnh",
  loading: "Chúng tôi đang chuẩn bị một công thức ngon.\nVui lòng chờ một chút.",
  retry: "Thử lại",
  cancel: "Hủy",
  yes: "Có",
  no: "Không",
  goToIngredient: "Phân tích nguyên liệu",
  goToRecipe: "Phân tích món ăn",
  recipe: {
    title: "Công thức AI",
    analysis_results: "Kết quả phân tích",
    ingredients: {
      title: "Nguyên liệu (1 người ăn)",
      view_more: 'Xem thêm {number} nguyên liệu',
      view_less: 'Gập lại',
    },
    how_to_cook: "Cách nấu",
    go_to_detail: "Xem công thức AI",
    description: "Giới thiệu công thức",
    calories: "Hàm lượng calories",
    time: "Thời gian nấu",
    ingredient: "Nguyên liệu chính",
    spice: "Gia vị",
    tip: "TIP",
  },
  ingredient: {
    title: "Phân tích hình ảnh",
    analysis_results: "Kết quả phân tích ảnh cho thấy nguyên liệu là như sau.",
    add_to_cart: "Thêm giỏ hàng",
    add_to_my_ingredients: "Thêm nguyên liệu",
  },
  msg: {
    not_ingredients: `Đây là một bức ảnh tuyệt vời,\ntuy nhiên đây là vùng dành riêng cho nguyên liệu!\nLần sau hãy chụp một nguyên liệu ngon nhé, bí mật của món ăn đang chờ đón bạn!\nBạn có muốn di chuyển  đến đầu bếp AI không?`,
    // AC-01-MSG-01
    not_recipes: `Hmm, đây không phải là món ăn rồi!\nChúng tôi chỉ có thể phân tích ảnh món ăn.\nVui lòng tải lên ảnh món ăn đã hoàn thiện.\nBạn có muốn di chuyển để phân tích nguyên liệu không?`,
    not_found: "Không tìm thấy",
    unknow: `Có vẻ như hình ảnh này\nkhông phải là món ăn hay nguyên liệu.\nChúng tôi sẽ phân tích tốt hơn\nnếu bạn tải lên hình ảnh món ăn hoặc nguyên liệu!`,
    upload_fail: `Tải lên không thành công do lỗi tạm thời.\nVui lòng thử lại sau.`,
    error: `Ôi! Không phân tích được hình ảnh rồi.\nHãy chọn lại ảnh,\nhoặc thử với bức ảnh rõ hơn nhé?`,
    bothType: `Có cả nguyên liệu và món ăn ở trong hình ảnh!\nVui lòng chọn phân tích theo phần nào trong hình ảnh.`,
  }
}
